<template>
	<div class="c-steps">
		<ul class="flex">
			<li v-for="(item, i) in steps" :key="i" class="flex-column flex-start-center" :class="{'z-now': i == active - 1}" :style="{'margin-left': i > 0 ? parsePixel(gap, true) : 0}">
				<div class="c-steps-dot flex-center">
					<i v-if="i < active - 1" class="c-icon-check"></i>
				</div>
				<div class="c-steps-text" :style="{'width': parsePixel(gap, true)}">
					<p>{{$t(item.name)}}</p>
				</div>
				<div v-if="i > 0" class="c-steps-line"></div>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'cSteps',
		
		props: {
			steps: Array,
			
			active: {
				type: [Number, String],
				default: 1
			},
			
			gap: {
				type: [Number, String],
				default: 1
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.c-steps {
		float: left;
		overflow: hidden;

		ul {
			float: left;
			padding: .14rem .5rem 0;
		}
		
		li {
			position: relative;
			width: .48rem;
			
			&.z-now {
				.c-steps-dot {
					background: #fff;
				}
				
				.c-steps-text {
					color: #999;
				}
				
				~ li {
					&:before {
						background: #bbb;
					}
				
					.c-steps-dot {
						border-color: #ccc;
						background: #fff;
					}
					
					.c-steps-text {
						color: #999;
					}
					
					.c-steps-line {
						background: #bbb;
					}
				}
			}
		}
		
		&-dot {
			box-sizing: border-box;
			width: .48rem;
			height: .48rem;
			border: .04rem solid #00ACA9;
			border-radius: 100%;
			color: #fff;
			background: #00ACA9;
		}
		
		&-text {
			margin-top: .14rem;
			font-size: .26rem;
			text-align: center;
			white-space: nowrap;
			color: #00ACA9;
		}
		
		&-line {
			position: absolute;
			right: calc(100% + .5rem - .13rem);
			top: .24rem;
			width: .26rem;
			height: .02rem;
			background: #bbb;
		}
	}
</style>
